import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIST_DANHSACHTAISAN,
  GET_LIST_TAISAN,
  // TAISAN_THEMMOI,
} from "actions/DanhSachTaiSan/actionTypes";
import {
  getListDanhSachTaiSanSuccess,
  getListDanhSachTaiSanFailure,
  getListTaiSanSuccess,
  getListTaiSanFailure,
  // themMoiTaiSanFailure,
  // themMoiTaiSanSuccess,
} from "actions/DanhSachTaiSan";
import DanhSachTaiSanApi from "service/danhSachTaiSanApi";
import { pushNotification } from "utils/notifications";

function* getListDanhSachTaiSan(action) {
  try {
    const response = yield call(DanhSachTaiSanApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachTaiSanSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListDanhSachTaiSanFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListDanhSachTaiSanFailure());
  }
}

function* getListTaiSan(action) {
  try {
    const response = yield call(
      DanhSachTaiSanApi.GetDanhSachTaiSan,
      action.dataSearch
    );
    // console.log(DanhSachTaiSanApi.GetDanhSachTaiSan);
    //yield put(getListTaiSanSuccess(response.data));
    if (response.ok) {
      yield put(getListTaiSanSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListTaiSanFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListTaiSanFailure());
  }
}

// function* themMoiTaiSan(action) {
//   try {
//     const response = yield call(
//       DanhSachTaiSanApi.GetDanhSachTaiSan,
//       action.dataSearch
//     );
//     //yield put(getListTaiSanSuccess(response.data));
//     if (response.ok) {
//       yield put(themMoiTaiSanSuccess(response.data));
//     } else {
//       pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
//       yield put(themMoiTaiSanFailure());
//     }
//   } catch (error) {
//     pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
//     yield put(themMoiTaiSanFailure());
//   }
// }

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHTAISAN, getListDanhSachTaiSan);
  yield takeLatest(GET_LIST_TAISAN, getListTaiSan);
  // yield takeLatest(TAISAN_THEMMOI, themMoiTaiSan);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
